<template>
  <div id="relatorios">
    <b-row class="pt-3 pb-2">
      <b-col sm="12 title">RELATÓRIOS</b-col>
    </b-row>
    <b-row class="input-search filtro relatFiltro shadow p-2">
      <b-col cols="3" id="selecRelat">
        <b-form-select size="sm" v-model="selected" :options="options" @change="selecionarRelatorio()"></b-form-select>
      </b-col>
      <!-- status -->
      <b-col cols="4" v-if="visibility.statusRel" id="selecStatus">
        <b-form-select size="sm" v-model="statusPedido" @change="onChange($event)">
          <template slot="first">
            <option :value="null" disabled>-- Status --</option>
          </template>
          <option v-for="(item, key) in statusOrdenados" :value="key" :key="item.codigo">
            {{item.descricao}}
          </option>
        </b-form-select>
      </b-col>
      <!-- ano e mes -->
      <b-col cols="2"  v-if="visibility.filtroMesAno" id="selecMes">
        <b-form-select size="sm" v-model="selectedMes" @change="onChange($event)">
          <template slot="first">
            <option :value="null" disabled>-- Mês --</option>
          </template>
          <option v-for="(item, key) in optionsMes" :value="key" :key="item.mes">
            {{item.descricao}}
          </option>
        </b-form-select>
      </b-col>
      <b-col cols="2" v-if="visibility.filtroMesAno" id="inputAno">
        <b-form-input placeholder="Ano" autocomplete="no" name="filter_date" step="1" v-on:keyup="changeClean()" onkeypress="return event.charCode >= 48 && event.charCode <= 57"  type="number" size="sm" v-validate="'after:1900|before:2100|date_format:yyyy'" data-vv-as="filter_date" v-model="anoSelecionado" @change="onChange($event)"></b-form-input>
      </b-col>
      <!-- trecho calendario -->
      <b-col cols="3" v-if="visibility.filtroGerencial" id="selecDate">
        <div class="datepicker-container with-button">
          <div class="datepicker-trigger">
            <b-button id="datepicker-button-trigger" size="sm">
              {{ formatDates(datePicker.buttonDateOne, datePicker.buttonDateTwo) || 'Período' }}
            </b-button>
            <airbnb-style-datepicker
              :trigger-element-id="'datepicker-button-trigger'"
              :mode="'range'"
              :date-one="datePicker.buttonDateOne"
              :date-two="datePicker.buttonDateTwo"
              :min-date="'2018-02-28'"
              :fullscreen-mobile="true"
              :months-to-show="2"
              :offset-y="10"
              :trigger="datePicker.trigger"
              v-on:date-one-selected="function(val) { datePicker.buttonDateOne = val }"
              v-on:date-two-selected="function(val) { datePicker.buttonDateTwo = val }"
              v-on:closed="onClosed"
              v-on:previous-month="onMonthChange"
              v-on:next-month="onMonthChange"
            ></airbnb-style-datepicker>
          </div>
        </div>
      </b-col>
      <b-col cols="2" class="pb-2" v-if="visibility.btnBuscar" id="btnBuscar">
        <b-button size="sm" @click="buscarDados()" :disabled="errors.has('filter_date')">Buscar</b-button>
      </b-col>
      <span v-if="errors.has('filter_date')" style="color: #7c000a" class="mt-1"><b>Digite uma data válida</b></span>
    </b-row>
    <b-row class="input-search filtro shadow p-2" id="filtroMob">
      <b-button id="abreModalFiltro" size="sm" v-on:click="abreModalFiltro()"><i class="fas fa-search mr-2"></i>Filtrar</b-button>
    </b-row>
    <b-modal
      v-model="modalFiltro"
      @ok="filtrar"
      hide-footer
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Filtrar Relatórios</h5>
      </template>
      <form>
        <div class="form-row m-0">
          <b-col cols="3" id="selecRelat">
            <b-form-select size="sm" v-model="selected" :options="options" @change="selecionarRelatorio()"></b-form-select>
          </b-col>
          <!-- status -->
          <b-col cols="4" v-if="visibility.statusRel" id="selecStatus">
            <b-form-select size="sm" v-model="statusPedido" @change="onChange($event)">
              <template slot="first">
                <option :value="null" disabled>-- Status --</option>
              </template>
              <option v-for="(item, key) in statusOrdenados" :value="key" :key="item.codigo">
                {{item.descricao}}
              </option>
            </b-form-select>
          </b-col>
          <!-- ano e mes -->
          <b-col cols="2"  v-if="visibility.filtroMesAno" id="selecMes">
            <b-form-select size="sm" v-model="selectedMes" @change="onChange($event)">
              <template slot="first">
                <option :value="null" disabled>-- Mês --</option>
              </template>
              <option v-for="(item, key) in optionsMes" :value="key" :key="item.mes">
                {{item.descricao}}
              </option>
            </b-form-select>
          </b-col>
          <b-col cols="2" v-if="visibility.filtroMesAno" id="inputAno">
            <b-form-input placeholder="Ano" autocomplete="no" name="filter_date" type="number" size="sm" v-validate="'after:1900|before:2100|date_format:yyyy'" data-vv-as="filter_date" v-model="anoSelecionado" @change="onChange($event)"></b-form-input>
          </b-col>
          <span v-if="errors.has('filter_date')" style="color: #7c000a" class="mt-1"><b>Digite uma data válida</b></span>
          <!-- trecho calendario -->
          <b-col cols="3" v-if="visibility.filtroGerencial" id="selecDate">
            <div class="datepicker-container with-button">
              <div class="datepicker-trigger">
                <b-button id="datepicker-button-trigger" size="sm">
                  {{ formatDates(datePicker.buttonDateOne, datePicker.buttonDateTwo) || 'Período' }}
                </b-button>
                <airbnb-style-datepicker
                  :trigger-element-id="'datepicker-button-trigger'"
                  :mode="'range'"
                  :date-one="datePicker.buttonDateOne"
                  :date-two="datePicker.buttonDateTwo"
                  :min-date="'2018-02-28'"
                  :fullscreen-mobile="true"
                  :months-to-show="2"
                  :offset-y="10"
                  :trigger="datePicker.trigger"
                  v-on:date-one-selected="function(val) { datePicker.buttonDateOne = val }"
                  v-on:date-two-selected="function(val) { datePicker.buttonDateTwo = val }"
                  v-on:closed="onClosed"
                  v-on:previous-month="onMonthChange"
                  v-on:next-month="onMonthChange"
                ></airbnb-style-datepicker>
              </div>
            </div>
          </b-col>
          <b-col cols="2" class="pb-2" v-if="visibility.btnBuscar" id="btnBuscar">
            <b-button size="sm" @click="buscarDados()">Buscar</b-button>
          </b-col>
        </div>
      </form>
    </b-modal>
    <relatorios-clientes-ranking  v-if="visibility.relCliRanking" :pObjClientes="objClientes" :pObjPaginacao="objPaginacao"></relatorios-clientes-ranking>
    <relatorios-clientes-nao-compram v-if="visibility.relCliNaoComp" :pObjClientes="objClientes" :pObjPaginacao="objPaginacao" :pTipoRelatorio="relatorioSelecionado"></relatorios-clientes-nao-compram>
    <relatorios-clientes-pendencia v-if="visibility.relCliPendencia" :pObjClientes="objClientes" :pObjPaginacao="objPaginacao"></relatorios-clientes-pendencia>
    <relatorios-pedido-vue v-if="visibility.relPedidos" :pObjPedido="objPedido" :pObjStatus="statusSelecionado"></relatorios-pedido-vue>
    <relatorios-comissoes v-if="visibility.relComissoes" :pResumoComissoes="resumoComissoes"></relatorios-comissoes>
    <relatorio-metas v-if="visibility.relMetas" :pMetasDados="metasDados" v-show="showRelMetas"></relatorio-metas>
    <relatorio-gerencial-vue v-if="visibility.relGerencial" :pRelatorioGerencialDados="relatorioGerencialDados"></relatorio-gerencial-vue>
    <BlockUI v-if="blockUI.visibility" :message="blockUI.message">
      <spinner-vue  id="modal-xl" ></spinner-vue>
    </BlockUI>
    <toast-vue :idToast="message.idToast" :variant="message.variant" :titleMsg="message.titleMsg" :message="message.message"></toast-vue>
  </div>
</template>
<script>
  import ToastVue from '@/components/layouts/toastVue'
  import spinnerVue from '@/components/items/SpinnerVue'
  import { broadcastServer } from '@/main'
  import relatoriosPedidoVue from '@/components/items/relatorioPedidosVue'
  import relatoriosClientesPendencia from '@/components/items/relatorioClientesPendenciaVue'
  import relatoriosClientesRanking from '@/components/items/relatorioClientesRankingVue'
  import relatoriosClientesNaoCompram from '@/components/items/relatorioClientesNaoCompramVue'
  import relatoriosComissoes from '@/components/items/relatoriosComissoesVue'
  import relatorioMetas from '@/components/items/relatorioMetasVue'
  import pedidosServices from '@/services/tablePedidos'
  import relatoriosService from '@/services/relatorios'
  // import RelatorioClientesVue from '@/components/items/relatorioClientesPendenciaVue'
  import relatorioGerencialVue from '@/components/items/relatorioGerencialVue'

  export default {
    components: {
      // RelatorioClientesVue,
      relatoriosPedidoVue,
      spinnerVue,
      ToastVue,
      relatoriosClientesPendencia,
      relatoriosClientesRanking,
      relatoriosClientesNaoCompram,
      relatoriosComissoes,
      relatorioMetas,
      relatorioGerencialVue
    },
    data () {
      return {
        cor: '',
        headerTextVariant: 'light',
        headerBgVariant: 'dark',
        modalFiltro: false,
        datePicker: {
          dateFormat: 'D MMM',
          buttonDateOne: '',
          buttonDateTwo: '',
          inlineDateOne: '',
          sundayDateOne: '',
          sundayFirst: false,
          alignRight: false,
          trigger: false
        },
        visibility: {
          relCliRanking: false,
          relCliNaoComp: false,
          relCliPendencia: false,
          relPedidos: false,
          relComissoes: false,
          relMetas: false,
          statusRel: true,
          relGerencial: false,
          filtroGerencial: false,
          filtroMesAno: false,
          btnBuscar: false
        },
        showRelMetas: false,
        blockUI: {
          message: '',
          visibility: false
        },
        message: {
          idToast: 'my-toast',
          titleMsg: '',
          message: '',
          variant: ''
        },
        selected: null,
        selectedMes: null,
        anoSelecionado: null,
        metasDados: {
          mesAtual: {},
          porCategoria: [],
          descricaoMes: []
        },
        options: [
          { value: null, text: '-- Relatório --' },
          { value: '1', text: 'Clientes' },
          { value: '2', text: 'Pedidos' },
          { value: '3', text: 'Comissões' },
          { value: '4', text: 'Metas' },
          { value: '5', text: 'Gerencial' }
        ],
        optionsClientes: [
          { codigo: 0, descricao: 'Com pendência financeira' },
          { codigo: 1, descricao: 'Ranking clientes ult. 6 meses' },
          { codigo: 2, descricao: 'Que não compram a 30 dias' },
          { codigo: 3, descricao: 'Que não compram a 60 dias' },
          { codigo: 4, descricao: 'Que não compram a 90 dias' }
        ],
        optionsMes: [
          { mes: 1, descricao: 'Janeiro' },
          { mes: 2, descricao: 'Fevereiro' },
          { mes: 3, descricao: 'Março' },
          { mes: 4, descricao: 'Abril' },
          { mes: 5, descricao: 'Maio' },
          { mes: 6, descricao: 'Junho' },
          { mes: 7, descricao: 'Julho' },
          { mes: 8, descricao: 'Agosto' },
          { mes: 9, descricao: 'Setembro' },
          { mes: 10, descricao: 'Outubro' },
          { mes: 11, descricao: 'Novembro' },
          { mes: 12, descricao: 'Dezembro' }
        ],
        codigo: null,
        statusPedidos: [],
        statusOrdenados: [],
        resumoComissoes: {},
        statusPedido: null,
        statusSelecionado: {},
        objPedido: [],
        paginacao: {},
        objClientes: [],
        objPaginacao: [],
        relatorioSelecionado: '',
        relatorioGerencialDados: {
          objPorCategorias: []
        }
      }
    },
    created () {
      window.addEventListener('beforeunload', this.toTopOnRefresh)
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      this.datePicker.buttonDateOne = firstDay.toJSON().slice(0, 10)
      this.datePicker.buttonDateTwo = lastDay.toJSON().slice(0, 10)
      this.selectedMes = (date.getMonth())
      this.anoSelecionado = date.getFullYear()
    },
    methods: {
      toTopOnRefresh: function toTopOnRefresh (event) {
        window.scrollTo(0, 0)
      },
      formatterValue: function (valor) {
        let val = (valor / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      buscarDados: function () {
        if (this.selected === '3') {
          this.listarComissao()
        } else if (this.selected === '4') {
          this.listarMetas()
        } else if (this.selected === '5') {
          this.listarGerencial()
        }
      },
      listarMetas: function () {
        let json = {
          mesAtual: {
            valorMedio: 0,
            percAtingido: 0,
            valorAtingido: 0,
            valorMeta: 0,
            codRepresentante: ''
          },
          porCategoria: []
        }
        this.metasDados = json
        this.blockUI.message = 'Listando Metas, aguarde...'
        this.blockUI.visibility = true
        if (typeof this.anoSelecionado === 'string') {
          this.anoSelecionado = parseInt(this.anoSelecionado)
        }
        let param = { mes: (this.selectedMes + 1), ano: this.anoSelecionado }
        // console.log(JSON.stringify(param))
        relatoriosService.listarMetas(param).then(response => {
          this.metasDados = response.data
          this.metasDados.porCategoria = response.data.porCategoria.sort(function (a, b) {
            return b.percAtingido - a.percAtingido
          })
          var mes = ''
          let meses = this.optionsMes.filter(m => m.mes === (this.selectedMes + 1))
          if (meses.length > 0) {
            mes = meses[0].descricao
          }
          this.metasDados.descricaoMes = mes
          this.showRelMetas = true
        }).catch(error => {
          console.log(error)
          if (error.response.status === 500) {
            console.log('500')
            this.metasDados = []
            this.metasDados.porCategoria = []
            this.metasDados.mesAtual = {}
          }
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      listarGerencial: function () {
        if (this.datePicker.buttonDateOne === '' || this.datePicker.buttonDateTwo === '') {
          this.showMessage('Selecione um periodo!', 'Atenção', 'danger')
          return
        }
        this.visibility.relPedidos = false
        this.blockUI.message = 'Listando Dados, aguarde...'
        this.blockUI.visibility = true
        let codRepresentante = ''
        let dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'))
        if (dadosAcesso.perfil.id === 3) {
          codRepresentante = dadosAcesso.representante.codigo
        }
        let param = {codRepresentante: codRepresentante, dataDe: this.datePicker.buttonDateOne, dataAte: this.datePicker.buttonDateTwo}
        relatoriosService.resumoGerencialPeriodo(param).then(response => {
          var data = response.data
          // CATEGORIA
          data.porCategoria = data.porCategoria.sort(function (a, b) {
            return a.ordem - b.ordem
          })
          // REPRESENTANTE
          data.porRepresentate = data.porRepresentate.sort(function (a, b) {
            return b.valor - a.valor
          })
          // CLIENTE
          data.porCliente = data.porCliente.sort(function (a, b) {
            return b.valor - a.valor
          })
          // UF
          data.porUFCliente = data.porUFCliente.sort(function (a, b) {
            return b.valor - a.valor
          })
          // DIA
          data.porDia = data.porDia.sort(function (a, b) {
            return a.emissaoDateOrder - b.emissaoDateOrder
          })
          // atualiza a variavel que gerencia o relatorio
          this.relatorioGerencialDados = data
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      filtrar: function () {
        let objectPost = {termo: this.termo, codStatus: this.codStatus, emissaoDe: this.dataDe, emissaoAte: this.dataAte}
        broadcastServer.$emit('filtrosSelecionados', objectPost)
      },
      formatDates: function (dateOne, dateTwo) {
        let formattedDates = ''
        if (dateOne) {
          this.dataDe = dateOne
          let dataFormatada = dateOne.substring(8, 10) + '/' + dateOne.substring(5, 7) + '/' + dateOne.substring(0, 4)
          // console.log(dataFormatada)
          formattedDates = dataFormatada // dateFns.format(dateOne, this.dateFormat)
        }
        if (dateTwo) {
          this.dataAte = dateTwo
          let dataFormatada = dateTwo.substring(8, 10) + '/' + dateTwo.substring(5, 7) + '/' + dateTwo.substring(0, 4)
          formattedDates += ' - ' + dataFormatada // dateFns.format(dateTwo, this.dateFormat)
        }
        // console.log(formattedDates)
        return formattedDates
      },
      onClosed: function () {
        let datesStr = this.formatDates(this.datePicker.buttonDateOne, this.datePicker.buttonDateTwo)
        console.log('Dates Selected: ' + datesStr)
        this.datePicker.trigger = false
      },
      onMonthChange: function (dates) {
        // console.log('months changed', dates)
      },
      limparFiltro: function () {
        this.termo = ''
        this.statusPedido = null
        this.dataDe = ''
        this.dataAte = ''
        this.datePicker.buttonDateOne = ''
        this.datePicker.buttonDateTwo = ''
        let objectPost = {termo: '', codStatus: '', emissaoDe: '', emissaoAte: ''}
        broadcastServer.$emit('filtrosSelecionados', objectPost)
      },
      showMessage: function (message, title, variantColor) {
        this.message.message = message
        this.message.titleMsg = title
        this.message.variant = variantColor
        this.$bvToast.show(this.message.idToast)
      },
      listarClientes: function (paramCliente) {
        relatoriosService.listarClientes(paramCliente).then(response => {
          this.objClientes = response.data.clientes
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      changeClean: function () {
        this.resumoComissoes = {
          aceite: {},
          extrato: [],
          porCategoria: [],
          valorMes: {
            valor: 0,
            mes: this.selectedMes
          }
        }
        this.resumoComissoes.mes = (this.selectedMes + 1)
        this.resumoComissoes.ano = this.anoSelecionado
        this.visibility.relMetas = true
        this.showRelMetas = false
        this.metasDados = {
          mesAtual: {
            valorMedio: 0,
            percAtingido: 0,
            valorAtingido: 0,
            valorMeta: 0,
            codRepresentante: ''
          },
          porCategoria: []
        }
      },
      onChange (index) {
        let statusSelecionado = this.statusOrdenados[index]
        if (typeof statusSelecionado !== 'undefined' && typeof statusSelecionado.codigo !== 'undefined') {
          this.relatorioSelecionado = statusSelecionado.codigo
        }
        this.metasDados.porCategoria = []
        this.metasDados.mesAtual = {}
        switch (this.selected) {
          case '1': // cliente
            this.blockUI.message = 'Listando Status, aguarde...'
            this.blockUI.visibility = true
            if (statusSelecionado.codigo === 0) { // com pendencia financeira
              this.visibility.relCliRanking = false
              this.visibility.relCliNaoComp = false
              this.visibility.relCliPendencia = true
              let paginacao = this.paginacao.clientesComPendenciaFinanceira
              this.objPaginacao = paginacao
              let registrosPorPagina = 50
              if (paginacao.length > 0) {
                registrosPorPagina = paginacao[0].registrosPorPagina
              }
              let paramCliente = {tipoRelatorio: statusSelecionado.codigo, paginacao: 0, registrosPorPagina: registrosPorPagina}
              this.listarClientes(paramCliente)
            } else if (statusSelecionado.codigo === 1) { // ranking
              this.visibility.relCliRanking = true
              this.visibility.relCliNaoComp = false
              this.visibility.relCliPendencia = false
              let paginacao = this.paginacao.clientesPorRanking
              this.objPaginacao = paginacao
              let registrosPorPagina = 50
              if (paginacao.length > 0) {
                registrosPorPagina = paginacao[0].registrosPorPagina
              }
              let paramCliente = {tipoRelatorio: statusSelecionado.codigo, paginacao: 0, registrosPorPagina: registrosPorPagina}
              this.listarClientes(paramCliente)
            } else if (statusSelecionado.codigo === 2 || statusSelecionado.codigo === 3 || statusSelecionado.codigo === 4) { // 30 - 60 - 90 dias que nao compram
              this.visibility.relCliRanking = false
              this.visibility.relCliNaoComp = true
              this.visibility.relCliPendencia = false
              let paginacao = []
              if (statusSelecionado.codigo === 2) {
                paginacao = this.paginacao.clientesQueNaoCompramHa30Dias
              } else if (statusSelecionado.codigo === 3) {
                paginacao = this.paginacao.clientesQueNaoCompramHa60Dias
              } else if (statusSelecionado.codigo === 4) {
                paginacao = this.paginacao.clientesQueNaoCompramHa90Dias
              }
              this.objPaginacao = paginacao
              let registrosPorPagina = 50
              if (paginacao.length > 0) {
                registrosPorPagina = paginacao[0].registrosPorPagina
              }
              let paramCliente = {tipoRelatorio: statusSelecionado.codigo, paginacao: 0, registrosPorPagina: registrosPorPagina}
              this.listarClientes(paramCliente)
            }
            break
          case '2': // pedidos
            this.blockUI.message = 'Listando Status, aguarde...'
            this.blockUI.visibility = true
            this.visibility.relPedidos = true
            // console.log(JSON.stringify(statusSelecionado))
            let paramPedido = {termo: '', codStatus: statusSelecionado.codigo, emissaoDe: '', emissaoAte: ''}
            pedidosServices.listarPedidos(paramPedido).then(response => {
              // console.log(response.data)
              this.statusSelecionado = statusSelecionado
              if (response.data.pedidos) {
                this.objPedido = response.data.pedidos
              } else {
                this.objPedido = []
              }
              // this.statusOrdenados = response.data.statusPedido.sort(function (a, b) {
              //   return a.ordem - b.ordem
              // })
              // this.statusPedidos = response.data.statusPedido
            }).catch(error => {
              console.log(error)
              this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
            }).finally(() => {
              this.blockUI.visibility = false
            })
            break
          case '3': // comissoes
            this.visibility.relComissoes = false
            break
          case '4': // metas
            this.visibility.relMetas = true
            this.showRelMetas = false
            this.metasDados = {
              mesAtual: {
                valorMedio: 0,
                percAtingido: 0,
                valorAtingido: 0,
                valorMeta: 0,
                codRepresentante: ''
              },
              porCategoria: []
            }
            break
          case '5': // gerencial
            break
        }
      },
      relatorioCliente: function () {
        relatoriosService.listarClientes().then(response => {
          this.clientes = response.data
          // console.log(this.clientes)
        })
      },
      segundoFiltroPedidos: function () {
        pedidosServices.listarSelect().then(response => {
          this.statusOrdenados = response.data.statusPedido.sort(function (a, b) {
            return a.ordem - b.ordem
          })
          // this.statusPedidos = response.data.statusPedido
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      segundoFiltroClientes: function () {
        this.visibility.relPedidos = false
        this.blockUI.message = 'Listando Status, aguarde...'
        this.blockUI.visibility = true
        relatoriosService.listarPaginacaoClientes().then(response => {
          this.paginacao = response.data
          this.statusOrdenados = this.optionsClientes
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      selecionarRelatorio: function () {
        // console.log(JSON.stringify(this.selected))
        this.metasDados.porCategoria = []
        this.metasDados.mesAtual = {}
        this.visibility.statusRel = true
        this.visibility.relMetas = false
        this.visibility.relPedidos = false
        this.visibility.relGerencial = false
        this.visibility.filtroGerencial = false
        this.visibility.filtroMesAno = false
        this.visibility.btnBuscar = false

        switch (this.selected) {
          case '1':
            this.blockUI.message = 'Listando Relatórios, aguarde...'
            this.blockUI.visibility = true
            this.segundoFiltroClientes()
            this.visibility.relComissoes = false
            break
          case '2':
            this.blockUI.message = 'Listando Relatórios, aguarde...'
            this.blockUI.visibility = true
            this.segundoFiltroPedidos()
            this.visibility.relComissoes = false
            this.visibility.relCliRanking = false
            this.visibility.relCliNaoComp = false
            this.visibility.relCliPendencia = false
            break
          case '3':
            // this.blockUI.message = 'Listando Relatórios, aguarde...'
            // this.blockUI.visibility = true
            this.visibility.filtroMesAno = true
            this.visibility.relMetas = false
            this.visibility.relComissoes = true
            this.visibility.relCliRanking = false
            this.visibility.relCliNaoComp = false
            this.visibility.relCliPendencia = false
            this.visibility.statusRel = false
            this.visibility.btnBuscar = true
            this.listarComissao()
            break
          case '4':
            // this.blockUI.message = 'Listando Relatórios, aguarde...'
            // this.blockUI.visibility = true
            this.visibility.filtroMesAno = true
            this.visibility.relComissoes = false
            this.visibility.relMetas = true
            this.visibility.relCliRanking = false
            this.visibility.relCliNaoComp = false
            this.visibility.relCliPendencia = false
            this.visibility.statusRel = false
            this.visibility.btnBuscar = true
            this.listarMetas()
            break
          case '5':
            this.visibility.relComissoes = false
            this.visibility.relCliRanking = false
            this.visibility.relCliNaoComp = false
            this.visibility.relCliPendencia = false
            this.visibility.relGerencial = true
            this.visibility.filtroGerencial = true
            this.visibility.statusRel = false
            this.visibility.btnBuscar = true
            break
        }
      },
      listarComissao: function () {
        this.blockUI.message = 'Listando Comissões, aguarde...'
        this.blockUI.visibility = true
        let param = { mes: (this.selectedMes + 1), ano: this.anoSelecionado }
        // console.log(JSON.stringify(param))
        relatoriosService.listarComissao(param).then(response => {
          this.resumoComissoes = response.data
          this.resumoComissoes.mes = (this.selectedMes + 1)
          this.resumoComissoes.ano = this.anoSelecionado
          this.visibility.relComissoes = true
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger')
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      abreModalFiltro: function () {
        this.modalFiltro = true
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/RelatoriosVue.vue